import { render, staticRenderFns } from "./CreateMenu.vue?vue&type=template&id=67fdf3f2&scoped=true"
import script from "./CreateMenu.vue?vue&type=script&lang=js"
export * from "./CreateMenu.vue?vue&type=script&lang=js"
import style0 from "./CreateMenu.vue?vue&type=style&index=0&id=67fdf3f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fdf3f2",
  null
  
)

export default component.exports